import { Box, Divider, Typography } from "@mui/material";
import SeverityOption from "../../components/filterOption/SeverityOption";

/**
 * Demo component for SeverityOption
 * Shows different types and configurations of the SeverityOption component
 */
const SeverityOptionDemo = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Severity type */}
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Severity Type:
        </Typography>
        <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap">
          <SeverityOption label="Critical" type="severity" />
          <SeverityOption label="High" type="severity" />
          <SeverityOption label="Medium" type="severity" />
          <SeverityOption label="Low" type="severity" />
        </Box>
      </Box>

      <Divider />

      {/* Jira type */}
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Jira Priority:
        </Typography>
        <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap">
          <SeverityOption label="Highest" type="jira" />
          <SeverityOption label="High" type="jira" />
          <SeverityOption label="Medium" type="jira" />
          <SeverityOption label="Low" type="jira" />
          <SeverityOption label="Lowest" type="jira" />
          <SeverityOption label="Triage" type="jira" />
        </Box>
      </Box>

      <Divider />

      {/* Entity Risk type */}
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Entity Risk:
        </Typography>
        <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap">
          <SeverityOption label="Critical" type="entityRisk" />
          <SeverityOption label="High" type="entityRisk" />
          <SeverityOption label="Medium" type="entityRisk" />
          <SeverityOption label="Low" type="entityRisk" />
          <SeverityOption label="Minimal" type="entityRisk" />
        </Box>
      </Box>

      <Divider />

      {/* Tenant Risk type */}
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Tenant Risk:
        </Typography>
        <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap">
          <SeverityOption label="Critical" type="tenantRisk" />
          <SeverityOption label="High" type="tenantRisk" />
          <SeverityOption label="Medium" type="tenantRisk" />
          <SeverityOption label="Low" type="tenantRisk" />
        </Box>
      </Box>
    </Box>
  );
};

export default SeverityOptionDemo;
